import React, { useEffect } from "react";

// Candidate hero images (office / interior with exterior view)
export const heroCandidates = [
  { id: 1, label: "Bureau lumineux, vue sur la ville (actuel)", url: "https://images.unsplash.com/photo-1497215842964-222b430dc094?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: 2, label: "Salle de réunion, grandes baies vitrées", url: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: 3, label: "Bureau ouvert avec postes de travail (photo de départ)", url: "https://images.unsplash.com/photo-1706689656095-168768dc20a5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: 4, label: "Open space moderne et design", url: "https://images.unsplash.com/photo-1656646424687-b303e1758b36?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: 5, label: "Fenêtre ouverte sur une rue parisienne", url: "https://images.unsplash.com/photo-1541628951107-a9af5346a3e4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: 6, label: "Vue sur les toits de Paris (heure dorée)", url: "https://images.unsplash.com/photo-1593474769219-fea89cf0bbef?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: 7, label: "Bureau élégant, lumière naturelle", url: "https://images.unsplash.com/photo-1524758631624-e2822e304c36?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: 8, label: "Espace de travail cosy et chaleureux", url: "https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: 9, label: "Poste de travail épuré près de la fenêtre", url: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: 10, label: "Bureau contemporain, vue urbaine", url: "https://images.unsplash.com/photo-1517502884422-41eaead166d4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
];

export default function HeroGallery() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-[#F4F0E9] py-16">
      <div className="mx-auto max-w-[1320px] px-5 lg:px-8">
        <p className="mb-3 flex items-center gap-3 text-[12px] font-semibold uppercase tracking-[0.2em] text-[#B08D57]">
          <span className="h-px w-8 bg-[#B08D57]" /> Choix de la photo du hero
        </p>
        <h1 className="font-serifDisplay text-[34px] leading-tight text-[#26241F] lg:text-[46px]">
          Une dizaine de propositions
        </h1>
        <p className="mt-3 max-w-2xl text-[16px] text-[#6e6a62]">
          Parcourez les visuels ci-dessous (bureaux / intérieurs avec vue extérieure) et indiquez-moi
          simplement le <strong>numéro</strong> que vous préférez : je l'appliquerai au hero.
        </p>

        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {heroCandidates.map((img) => (
            <figure key={img.id} className="overflow-hidden rounded-2xl border border-[#e0d8c8] bg-[#FBF9F5] shadow-[0_10px_30px_-18px_rgba(38,36,31,0.35)]">
              <div className="relative aspect-[16/10] w-full overflow-hidden">
                <img src={img.url} alt={img.label} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 hover:scale-105" />
                <span className="absolute left-3 top-3 flex h-9 w-9 items-center justify-center rounded-full bg-[#26241F] text-[15px] font-bold text-white">
                  {img.id}
                </span>
              </div>
              <figcaption className="px-4 py-3 text-[14px] font-medium text-[#403d35]">
                {img.label}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </div>
  );
}
